export const extendedBuyerLeadPostcodes = [
61348,
61350,
61352,
61381,
61440,
61462,
61476,
65760,
65824,
65843,
60437,
60314,
60316,
60318,
60320,
60322,
65812,
60323,
60325,
60326,
60327,
60385,
60386,
60389,
60431,
60435,
60439,
60486,
60487,
60488,
60489,
60528,
60529,
60594,
60596,
60598,
60599,
65929,
65931,
65933,
65934,
65936,
60306,
60308,
60310,
60311,
60312,
60313,
60329,
60438,
61449,
61479,
38226,
38228,
38229,
38239,
38259,
38300,
38302,
38304,
38100,
38102,
38104,
38106,
38108,
38110,
38112,
38114,
38116,
38118,
38120,
38122,
38124,
38126,
38162,
38179,
21745,
21762,
27432,
27474,
27476,
27607,
30159,
30159,
30161,
30161,
30163,
30165,
30167,
30169,
30171,
30173,
30175,
30177,
30179,
30419,
30449,
30451,
30453,
30459,
30519,
30521,
30539,
20095,
30559,
30625,
30629,
30655,
30657,
20255,
20257,
20259,
30659,
30823,
30826,
30827,
30851,
20459,
30853,
30855,
30880,
30890,
30900,
30916,
30926,
30938,
30952,
30966,
30974,
30989,
31249,
31275,
31303,
31311,
31319,
31832,
34117,
34119,
34121,
34123,
34125,
34127,
34131,
34132,
34134,
34212,
34225,
34246,
34253,
34260,
34266,
34270,
34277,
21755,
21756,
34281,
21763,
21765,
21769,
21770,
21772,
21775,
21776,
21781,
21782,
21785,
21787,
21789,
34289,
34289,
34302,
34305,
34355,
34369,
34454,
34466,
34497,
34513,
34537,
34549,
34560,
34582,
34587,
35114,
22559,
25489,
25491,
25491,
20355,
20357,
20359,
22525,
22529,
22549,
22587,
22589,
22605,
22607,
22609,
22609,
22761,
27412,
22763,
27442,
27472,
22765,
22767,
27478,
27568,
27570,
27572,
27574,
27576,
27578,
27578,
27580,
22767,
27612,
27616,
27619,
27624,
27628,
27639,
22769,
22880,
25488,
30455,
30457,
30627,
30669,
34128,
34130,
34233,
34292,
34295,
34298,
34308,
34311,
34314,
34317,
34320,
34327,
34329,
34376,
34379,
34385,
34388,
34393,
34477,
34516,
34590,
34596,
34599,
34632,
35110,
38271,
38272,
38274,
38275,
38277,
38279,
38312,
38315,
38319,
38321,
38324,
38327,
38329,
38533,
10318,
10319,
10585,
10587,
10589,
10623,
10623,
10625,
10627,
10629,
10707,
10709,
10711,
10719,
10789,
12103,
12105,
12107,
12107,
12109,
12157,
12159,
12161,
12163,
12165,
12167,
12169,
12203,
12205,
12207,
12209,
12247,
12249,
12277,
12279,
12305,
12305,
12307,
12309,
12349,
12351,
12353,
12355,
12357,
12439,
12459,
12487,
12489,
12524,
12526,
12527,
12555,
12557,
12559,
12559,
12587,
12589,
13403,
13405,
13435,
13437,
13439,
13465,
13467,
13469,
13503,
13505,
13507,
13509,
13597,
13627,
13629,
14050,
14052,
14053,
14055,
14057,
14059,
14109,
14129,
14163,
14165,
14167,
14169,
14193,
14195,
14197,
14199,
15517,
15526,
15528,
15537,
15566,
15569,
15711,
15712,
15713,
15732,
15738,
15741,
15745,
15746,
15748,
15754,
15757,
15827,
15834,
15859,
15864,
16540,
16547,
16548,
16552,
16562,
16567,
16761,
81673,
80333,
80335,
80336,
80339,
80469,
80538,
80797,
80802,
80804,
80805,
80807,
80809,
80937,
80939,
80993,
80995,
81369,
81371,
81373,
81379,
81476,
81477,
81539,
81541,
81543,
81547,
81549,
81667,
81669,
81671,
81675,
81677,
81679,
81925,
81929,
82031,
82049,
80331,
80337,
80539,
80796,
80798,
80799,
80801,
80803,
80933,
80935,
81479,
81545,
81545,
81927,
82064,
82065,
82067,
82069,
85551,
85609,
85716,
85737,
85748,
85764,
85774,
40210,
40211,
40211,
40213,
40215,
40217,
40219,
40221,
40223,
40225,
40227,
40229,
40231,
40233,
40235,
40237,
40239,
40468,
40470,
40472,
40474,
40476,
40477,
40479,
40489,
40545,
40547,
40549,
40589,
40591,
40593,
40595,
40597,
40599,
40625,
40627,
40629,
40667,
40668,
40670,
40878,
40880,
40882,
40883,
40885,
41460,
41462,
41464,
41466,
41468,
41469,
41470,
41472,
41515,
41516,
41517,
41539,
41540,
41541,
41542,
41564,
41569,
45127,
45128,
45130,
45131,
45133,
45134,
45136,
45138,
45139,
45141,
45143,
45144,
45145,
45147,
45149,
45219,
45239,
45257,
45259,
45276,
45277,
45279,
45289,
45307,
45309,
45326,
45327,
45329,
45355,
45356,
45357,
45359,
40212,
50667,
50667,
50668,
50670,
50672,
50674,
50676,
50677,
50678,
50679,
50733,
50735,
50735,
50737,
50739,
50765,
50767,
50769,
50823,
50825,
50827,
50829,
50858,
50859,
50931,
50933,
50935,
50937,
50939,
50939,
50968,
50969,
50996,
50997,
50999,
51061,
51063,
51065,
51067,
51069,
51103,
51105,
51107,
51109,
51143,
51145,
51147,
51149,
51427,
51429,
51465,
51469,
51491,
51503,
51515,
51467,
51519,]
